export default {
  'receipt.title': 'Πληροφορίες παραλαβής',
  'receipt.btn.add': 'Προσθήκη αποδειξης παραλαβής',
  'receipt.btn.import': 'Εισαγωγή απόδειξης παραλαβής',
  'receipt.btn.export': 'Εξαγωγή απόδειξης παραλαβής',
  'receipt.input.placeholder': 'Παρακαλώ εισάγετε απόδειξη παραλαβής',
};
